/**
 * Convert a machine-friendly name (e.g. service_type, serviceType, service-type)
 * into a human-friendly label (e.g. Service Type)
 * @param {string} name - the machine-friendly name to convert
 * @returns {string} - the human-friendly label
 */
export function prettyPrintName(name: string): string {
  if (!name) return "";

  // Replace underscores or dashes with spaces
  let s = name.replace(/[_-]+/g, " ");

  // Insert spaces before camelCase capitals (e.g. serviceType -> service Type)
  s = s.replace(/([a-z0-9])([A-Z])/g, "$1 $2");

  // Split into words and normalize casing: capitalize first letter, lower-case the rest
  const words = s
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => {
      const lw = w.toLowerCase();
      return lw.charAt(0).toUpperCase() + lw.slice(1);
    });

  return words.join(" ");
}

export default prettyPrintName;
